package com.xtream.data_kmp.util.extension

 fun <T> List<T>.toggle(item: T): List<T> =
    if (contains(item)) minus(item)
    else plus(item)